import { ReverseEntries, ReverseEnum } from 'utils/tsUtils';

export enum EPalettes {
  HSLUV_1 = '1',
  HSLUV_2 = '2',
  HSLUV_3 = '3',
  HSLUV_4 = '4',
  HSLUV_5 = '5',
  HSLUV_6 = '6',
  HSLUV_7 = '7',
  HSLUV_8 = '8',
  HSLUV_9 = '9',
  HSV_1 = '10',
  HSV_2 = '11',
  HSV_3 = '12',
  HSV_4 = '13',
  HSV_5 = '14',
  HSV_6 = '15',
  OKHSV_1 = '16',
  OKHSL_1 = '17',
}

export type ReverseEPalettesEntries = ReverseEntries<typeof EPalettes>;

export type ReverseEPalettes = ReverseEnum<typeof EPalettes>;
